import React, { useState } from 'react';
import block from 'bem-cn';
import { useDispatch } from 'react-redux';

import { actions } from 'features/creativeFunctionality/redux';
import SVG from 'components/SVG';

import arrowSVG from '../img/arrow.svg';
import crossSVG from '../img/cross.svg';

import './NotificationsCustomItem.scss';

const b = block('notifications-custom-item-desktop');

const NotificationsCustomItem = ({ item, handleGetNotificationsRequest }) => {
  const dispatch = useDispatch();

  const [opened, setOpened] = useState(false);

  return (
    <div className={b({ opened })}>
      <div className={b('id')}>{item.id}</div>
      <div className={b('text', { opened })}>{item.notificationBody}</div>
      <SVG
        onClick={() => {
          setOpened(!opened);
        }}
        className={b('arrow', { opened })}
        svgProps={{ svg: arrowSVG }}
      />
      <SVG
        onClick={() => {
          dispatch(actions.deleteCustomRequest({ id: item.id }, handleGetNotificationsRequest));
        }}
        className={b('cross')}
        svgProps={{ svg: crossSVG }}
      />
    </div>
  );
};

export default NotificationsCustomItem;
